const initTheme = () => {
  if (
    localStorage.theme === 'dark' ||
    (!('theme' in localStorage) &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)
  ) {
    document.documentElement.classList.add('dark');
    document.documentElement.dataset.theme = 'dark';
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.dataset.theme = 'light';
  }
  if (document.querySelector('#ghost-comments-root iframe')) {
    toggleCommentsTheme(document.documentElement.dataset.theme);
  }
};

const toggleTheme = () => {
  const switchTheme = () => {
    document.documentElement.classList.toggle('dark');
    const newTheme = document.documentElement.classList.contains('dark')
      ? 'dark'
      : 'light';
    document.documentElement.dataset.theme = newTheme;
    if (document.querySelector('#ghost-comments-root iframe')) {
      toggleCommentsTheme(newTheme);
    }
    localStorage.setItem('theme', newTheme);
  };
  const themeToggleButtons = document.querySelectorAll('[data-toggle-theme]');
  themeToggleButtons.forEach((themeToggleButton) => {
    themeToggleButton.addEventListener('click', switchTheme);
  });
};

const toggleCommentsTheme = (theme) => {
  const comments = document
    .querySelector('#ghost-comments-root iframe')
    .contentWindow.document.querySelector('.ghost-display');
  theme === 'dark'
    ? comments.classList.add('dark')
    : comments.classList.remove('dark');
};

export { initTheme, toggleTheme };
